<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-button size="mini" @click="addRecord">添加记录</el-button>
            <el-button size="mini" @click="uploadFile">上传文件</el-button>
            <el-button size="mini" @click="getList">刷新列表</el-button>
            <span style="margin: 0 10px;">{{updateDate}}</span>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            :height="tableHeight"
            border
        >
            <el-table-column label="ID" width="80" align="center" fixed>
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Auto-Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.auto_acos }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Res-Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.res_acos }}</div>
                </template>
            </el-table-column>
            <el-table-column label="品牌-Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.brand_acos }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Asin-Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin_acos }}</div>
                </template>
            </el-table-column>

            <el-table-column label="Skag-Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.skag_acos }}</div>
                </template>
            </el-table-column>

            <el-table-column label="Skag-Tos-Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.skag_tos_acos }}</div>
                </template>
            </el-table-column>

            <el-table-column label="Skag-Ros-Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.skag_ros_acos }}</div>
                </template>
            </el-table-column>

            <el-table-column label="长尾-Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.changwei_acos }}</div>
                </template>
            </el-table-column>
            <el-table-column label="腰部-Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.yaobu_acos }}</div>
                </template>
            </el-table-column>
            <el-table-column label="高于acos预算系数" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.higher_acos_coefficient }}</div>
                </template>
            </el-table-column>
            <el-table-column label="低于acos预算系数" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.lower_acos_coefficient }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0单有花费系数" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.sales_0_coefficient }}</div>
                </template>
            </el-table-column>
            <el-table-column label="查询日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.date }}</div>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time}}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="270" fixed="right">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.status === -1" style="margin: 5px 0 5px 10px"
                               @click="showErrorInfo(scope.row)" type="danger" size="mini">解析失败
                    </el-button>
                    <el-button
                        v-if="scope.row.status === 0"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="startDecode(scope.row)"
                    >开始解析
                    </el-button
                    >
                    <el-button
                        v-if="scope.row.status === 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                    >解析中
                    </el-button
                    >
                    <el-button
                        v-if="scope.row.status !== 0 && scope.row.status !== 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="startDecode(scope.row, 1)"
                    >重新解析
                    </el-button>
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="downLoad(scope.row)"
                        v-if="scope.row.status == '2'">下载
                    </el-button>
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        @click="delete_records(scope.row)"
                    >删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :page-sizes="[20, 50, 100]"
                :total="query.total"
                background
                style="float: right;margin-top: 10px; padding-bottom: 30px"
                layout="total, sizes, prev, pager, next"
            >
            </el-pagination>
        </el-row>
        <add-report :visible="showAddRecord"
                    :title="'添加每日活动报告'"
                    @close-callback="showAddRecord = false" @refresh="getList()"></add-report>
        <uploadReport :visible="showUpload"
                      :title="'上传SP每日广告活动报告'"
                      @close-callback="showUpload = false"></uploadReport>
        <el-dialog style="padding: 0 20px 20px 20px !important;" width="30%" center title="错误信息" v-if="errorInfoShow"
                   :visible.sync="errorInfoShow">
            <span style="color: red">错误内容：</span>
            <span>{{errorMsg}}</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
			</span>
        </el-dialog>
    </div>
</template>
<script>
    import * as api from '@/api/statistics/statistics'
    import AddReport from '../addReport'
    import uploadReport from './uploadReport'
    import {binary_download, downloadFileUrl} from '../../../utils/method'

    export default {
        name: 'spActivityReport',
        components: {AddReport, uploadReport},
        data() {
            return {
                errorInfoShow: false,
                showAddRecord: false,
                showUpload: false,
                tableHeight: null,
                list: [],
                loading: false,
                query: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    state: '',
                    order: '',
                },
                updateDate: ''
            }
        },
        mounted() {
            this.getList()
            this.tableHeight =
                window.innerHeight - 710 - this.$refs.form.$el.offsetHeight;
            const that = this;
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == "object") {
                        that.tableHeight =
                            window.innerHeight -
                            710 -
                            that.$refs.form.$el.offsetHeight;
                    }
                })();
            };
        },
        watch: {
            tableHeight(val) {
                this.tableHeight = val;
            }
        },
        methods: {
            showErrorInfo(info) {
                this.errorInfoShow = true
                this.errorMsg = info.parsing_err_msg
            },
            downLoad(data) {
                const path = data.parsing_path
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            async startDecode(row, force = 0) {
                if (force) {
                    await this.$confirm('是否重新运行解析任务', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }
                let list = JSON.parse(JSON.stringify(this.list))
                api.budget_control_parse({
                    id: row.id,
                    force
                }).then(() => {
                    const index = list.findIndex(item => item.id === row.id)
                    list[index].status = 1
                    this.list = list
                })
            },
            delete_records(data) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.budget_control_del({id: data.id}).then(() => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                })
            },
            addRecord() {
                this.showAddRecord = true
            },
            uploadFile() {
                this.showUpload = true
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                api.budget_control_list({
                    ...this.query,
                    state: this.$route.query.state,
                    asin: this.$route.query.asin
                }).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.list = res.data.list
                        this.query.total = res.data.total
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    this.loading = false
                })

                api.advertising_budget_get_duration_date({
                    state: this.$route.query.state,
                    asin: this.$route.query.asin
                }).then(res => {
                    this.updateDate = res.data
                })
            },
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    .table_content {
        margin-top: 10px;
    }
</style>
